'use client';

import { useEffect, useState } from 'react';
import { useTheme } from 'next-themes';
import { Button } from '@/components/ui/button';

export default function ThemeSwitch() {
  const [mounted, setMounted] = useState(false);
  const [showButton, setShowButton] = useState(false);
  const { setTheme, resolvedTheme } = useTheme();

  useEffect(() => {
    setMounted(true);
  }, []);

  useEffect(() => {
    if (mounted) {
      setShowButton(false);
      requestAnimationFrame(() => setShowButton(true));
    }
  }, [mounted, resolvedTheme]);

  if (!mounted) {
    const isDark = resolvedTheme === 'dark';

    return (
      <Button
        variant="outline"
        aria-label="Toggle theme"
        className={`bg-primary-foreground dark:bg-primary-foreground hover:bg-secondary dark:hover:bg-secondary
          hidden size-12 transform items-center justify-center self-center rounded-sm transition-all
          duration-300 ease-in-out lg:inline-flex`}>
        {isDark ? (
          <span
            className={`${showButton ? 'scale-100 opacity-100 transition-all duration-300 ease-in-out' : 'scale-50 opacity-0 transition-all duration-300 ease-in-out'}`}>
            {''}
          </span>
        ) : (
          <span
            className={`${showButton ? 'scale-100 opacity-100 transition-all duration-300 ease-in-out' : 'scale-50 opacity-0 transition-all duration-300 ease-in-out'}`}>
            {''}
          </span>
        )}
      </Button>
    );
  }

  const isDark = resolvedTheme === 'dark';

  const handleToggle = () => {
    setTheme(isDark ? 'light' : 'dark');
  };

  return (
    <Button
      variant="outline"
      onClick={handleToggle}
      aria-label="Toggle theme"
      className={`bg-primary-foreground dark:bg-primary-foreground hover:bg-secondary dark:hover:bg-secondary
        hidden size-12 transform items-center justify-center self-center rounded-sm transition-all
        duration-300 ease-in-out lg:inline-flex`}>
      {isDark ? (
        <span
          className={`${showButton ? 'scale-100 opacity-100 transition-all duration-300 ease-in-out' : 'scale-50 opacity-0 transition-all duration-300 ease-in-out'}`}>
          {'🌙'}
        </span>
      ) : (
        <span
          className={`${showButton ? 'scale-100 opacity-100 transition-all duration-300 ease-in-out' : 'scale-50 opacity-0 transition-all duration-300 ease-in-out'}`}>
          {'☀️'}
        </span>
      )}
    </Button>
  );
}
